export default __webpack_public_path__ + "static/media/UserGuide_fr_FR.e4cf7775.pdf";